import * as types from "./types";

export function closeModal() {
  return (dispatch, getState) => {
    dispatch({ type: types.CLOSE_MODAL });
  };
}

export function openModal(typeModal="", titleModal="", messageModal="") {
  return (dispatch, getState) => {
    dispatch({
      type: types.OPEN_MODAL,
      modalOptions: { typeModal: typeModal, titleModal: titleModal, messageModal: messageModal }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/modal.js